// Components/MessagesArea/components/ConversationStart.jsx
import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const ConversationStart = () => {
    return (
        <Box sx={{ textAlign: 'center', margin: '10px 0', color: '#aaa' }}>
            <Typography variant="body2">
                Inicio de la conversación
            </Typography>
            <Divider sx={{ backgroundColor: '#374045', margin: '5px 0' }} />
        </Box>
    );
};

export default ConversationStart;